import {
  Table,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
} from "@/components/ui/table";
import { formatCurrency } from "@/utils/format/currency";
import { formatInTimeZone } from "date-fns-tz";

export const DownsellCyclesTable = ({ data, showTitle }: any) => {
  return (
    <div className="block w-full bg-white border rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
      <Table>
        {showTitle && (
          <TableHeader>
            <TableRow>
              <div className="text-2xl font-semibold font-['Inter'] leading-loose p-4">
                Ciclos Afetados
              </div>
            </TableRow>
          </TableHeader>
        )}
        <TableHeader className="h-[52px]">
          <TableRow>
            <TableHead className="px-4 text-zinc-500">ID do Ciclo</TableHead>
            <TableHead className="px-4 text-zinc-500">
              Data de início do ciclo
            </TableHead>
            <TableHead className="px-4 text-zinc-500">Antes</TableHead>
            <TableHead className="px-4 text-zinc-500">Depois</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data?.updatedCycles?.map((cycle: any) => {
            return (
              <TableRow className="h-[52px]" key={cycle.cycleId}>
                <TableCell className="px-4">{cycle.cycleId}</TableCell>
                <TableCell className="px-4">
                  {formatInTimeZone(cycle.startDate, "UTC", "dd/MM/yyyy")}
                </TableCell>
                <TableCell className="px-4">
                  <div>{`${cycle.oldCapacity} créditos`}</div>
                  <div>{formatCurrency(cycle.oldAmount)}</div>
                </TableCell>
                <TableCell className="px-4">
                  <div>{`${cycle.newCapacity} créditos`}</div>
                  <div>{formatCurrency(cycle.newAmount)}</div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
